module.exports = __webpack_public_path__ + "static/media/CARD_PLATINUM@3x.8daff135.png";